import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useParams } from 'react-router-dom';

import { Loadable } from 'common/components';
import { useJoinOrganizationMutation } from 'organization/api';
import ErrorPage from 'pages/ErrorPage';

export const JoinOrganization = () => {
  const { t: tLoading } = useTranslation('common', { keyPrefix: 'loading' });

  const [joinOrganization, { isLoading, isSuccess, isUninitialized, error }] = useJoinOrganizationMutation();
  const { organizationId } = useParams<{ organizationId: string }>();

  useEffect(() => {
    joinOrganization({
      organizationId: Number(organizationId),
    });
  }, [organizationId, joinOrganization]);

  return (
    <Loadable label={tLoading('joiningYourOrganization')} isLoading={isUninitialized || isLoading}>
      {isSuccess ? <Redirect to="/" /> : <ErrorPage title="Unable to join organization" error={error} />}
    </Loadable>
  );
};
